import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService, { type AiAnswerMode } from '../services'

export function useMutationUpdateChatAiMode() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (params: { roomId: string; aiAnswerMode: AiAnswerMode }) =>
			chatService.updateChatAiMode(params.roomId, params.aiAnswerMode),
		onSuccess: (_data, variables) => {
			toast.success('อัปเดตโหมด AI แล้ว')
			queryClient.invalidateQueries({
				queryKey: chatKeys.room(variables.roomId),
			})
			queryClient.invalidateQueries({ queryKey: chatKeys.rooms() })
		},
		onError: () => {
			toast.error('อัปเดตโหมด AI ไม่สำเร็จ')
		},
	})
}
